/**
 * Password policy — must match the strict backend rules in `backend/models.py`.
 * Min 10 chars + letter + number + symbol.
 */
export const PASSWORD_RULES = [
  { id: "len", label: "At least 10 characters", test: (p) => p.length >= 10 },
  { id: "letter", label: "Contains a letter (a–z, A–Z)", test: (p) => /[A-Za-z]/.test(p) },
  { id: "digit", label: "Contains a number (0–9)", test: (p) => /\d/.test(p) },
  { id: "symbol", label: "Contains a symbol (e.g. ! @ # $ %)", test: (p) => /[^A-Za-z0-9]/.test(p) },
];

export function evaluatePassword(password = "") {
  const passed = PASSWORD_RULES.map((r) => ({ ...r, ok: r.test(password) }));
  const score = passed.filter((r) => r.ok).length; // 0..4
  const allPassed = score === PASSWORD_RULES.length;

  let label = "Too weak";
  let color = "#dc2626"; // red-600
  if (score >= 4) {
    label = "Strong";
    color = "#16a34a"; // green-600
  } else if (score === 3) {
    label = "Almost there";
    color = "#f59e0b"; // amber-500
  } else if (score === 2) {
    label = "Weak";
    color = "#f97316"; // orange-500
  }
  return { rules: passed, score, allPassed, label, color };
}

// Reasonably permissive email regex — server is the final authority.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export function isValidEmail(email = "") {
  return EMAIL_RE.test(email.trim());
}
